import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SharedDataService } from '../../../services/shared-data.service';
import { AutoUnsubscribe } from '../../../decorators/auto-unsubscribe';
import { BorrowerService } from '../../../services/borrower.service';

@Component({
    selector: 'app-currency-format-switcher',
    templateUrl: './currency-format-switcher.component.html',
    styleUrls: ['./currency-format-switcher.component.scss'],
    standalone: false
})
@AutoUnsubscribe('subsArr$')
export class CurrencyFormatSwitcherComponent implements OnInit {
  digitsToTrim = 0;
  subsArr$: Subscription[] = [];

  currencyOptions = [
    {id: 0, text: 'Full value'},
    {id: 3, text: 'Round off to thousands'},
  ];

  constructor(private sharedDataService: SharedDataService,
              private companyService: BorrowerService) {
    this.sharedDataService.roundToThousandsDefaultBeenSet$.next(false);
  }

  ngOnInit(): void {
    if (this.sharedDataService.roundToThousandsDefaultBeenSet$.value === false) {
      if (this.companyService.getSetting('roundToThousands') === true ) {
        this.setCurrencyDigitsToTrim(this.currencyOptions[1].id);
      } else {
        this.setCurrencyDigitsToTrim(this.currencyOptions[0].id);
      }
      this.sharedDataService.roundToThousandsDefaultBeenSet$.next(true);
    }

    this.subsArr$.push(this.sharedDataService.currencyDigitsToTrim$.subscribe(v => {
      this.digitsToTrim = v;
    }))
  }

  setCurrencyDigitsToTrim(digitsToTrim: number) {
    this.sharedDataService.currencyDigitsToTrim$.next(digitsToTrim);
  }
}
